import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UILink from 'UIComponents/link/UILink';
const WorkflowDetailsTitlePropTypes = {
  isExternalLink: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  workflowName: PropTypes.string.isRequired,
  workflowUrl: PropTypes.string
};
export const WorkflowDetailsTitle = ({
  isExternalLink,
  onClick,
  workflowName,
  workflowUrl
}) => {
  return /*#__PURE__*/_jsx(UILink, {
    className: "display-block",
    external: isExternalLink,
    href: workflowUrl,
    onClick: onClick,
    children: workflowName
  });
};
WorkflowDetailsTitle.propTypes = WorkflowDetailsTitlePropTypes;
export default WorkflowDetailsTitle;